import styled from 'styled-components';
import { Box, Card, Stack } from 'src/viewLayer/components/DesignSystem';
import tokens from '@lessonnine/design-tokens.lib/dist/json/variables.json';
import devices from 'src/viewLayer/styling/mixins/media-queries';
import type { BabbelTheme } from '@lessonnine/design-tokens.lib/dist/json/theme';

export const PageContainer = styled(Stack)`
  gap: ${tokens.size.space.large};
  margin: ${tokens.size.space.large} ${tokens.size.space.small};

  @media ${devices.frommedium} {
    gap: ${tokens.size.space.xxlarge};
    margin: ${tokens.size.space.xxlarge} ${tokens.size.space.small};
  }
`;

export const LanguageContainer = styled(Card)`
  background-color: ${({ theme }: { theme: BabbelTheme }): string =>
    theme.color.accentInverse.enabled};
  border: 1px solid ${({ theme }: { theme: BabbelTheme }): string =>
    theme.color.accentInverse.enabledBorderSubdued};
  border-radius: ${tokens.size.radius.large};
`;

export const HeaderContainer = styled(Box)`
  margin: 0 1rem;
  text-align: center;
`;
